import styled from 'styled-components'
import { get } from '@utils'

export const H6 = styled.h6`
  ${get('styles.h6')};
`
